import { render, staticRenderFns } from "./productType.vue?vue&type=template&id=1711906e&scoped=true"
import script from "./productType.vue?vue&type=script&lang=js"
export * from "./productType.vue?vue&type=script&lang=js"
import style0 from "./productType.vue?vue&type=style&index=0&id=1711906e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1711906e",
  null
  
)

export default component.exports